import { Component, OnInit } from '@angular/core';
import { ActivatedRoute, Router } from '@angular/router';

import { MetaDefinition } from '@angular/platform-browser';
import { CompDetailService } from '@b2b/core/api/detail/detail.service';
import { ImageOptimizerService } from '@sparro/app/core/helpers/image-optimizer';
import { MetaService } from '@sparro/app/core/helpers/meta/meta.service';
import _ from 'lodash';
import { UNI_CONSTANTS } from '@sparro/app/core/config/constants.config';

@Component({
  selector: 'app-partners',
  templateUrl: './partners.component.html',
  styleUrls: ['./partners.component.scss']
})

export class PartnersComponent implements OnInit {
  compSlug: string;
  partnerSlug: string;
  modules: any = [];
  isLoading: boolean = false;
  defaultImage: string = UNI_CONSTANTS.NO_IMAGE.COMP_OR_PROJECT;

  constructor(
    public route: ActivatedRoute,
    public router: Router,
    public metaService: MetaService,
    private about: CompDetailService,
    public imageOptimizer: ImageOptimizerService
  ) {}

  ngOnInit(): void {
    this.compSlug = this.route.parent.snapshot.params.comp_slug;
    this.partnerSlug = this.route.snapshot.params.partner_slug;
    this.getPartnerModule();
  }

  ngDoCheck(): void {
    if (this.partnerSlug !== this.route.snapshot.params.partner_slug) {
      this.partnerSlug = this.route.snapshot.params.partner_slug;
      this.getPartnerModule();
    }
  }

  openLink(link: string): void {
    window.open(link, '_blank');
  }

  getPartnerModule(): void {
    this.isLoading = true;
    this.about.partnerModule(this.compSlug, this.partnerSlug).subscribe(
      (response) => {
        this.modules = _.sortBy(response, 'sub_heading');
        this.updateMetaInfo();
        this.isLoading = false;
      }, (error) => {
        console.log(error);
        this.isLoading = false;
      }
    );
  }

  updateMetaInfo(): void {
    this.about.fetchCompetition(this.compSlug, (competition) => {
      let metaInfo: MetaDefinition[] = [];

      const title = `${competition.title} ${competition.disciplines[0]?.name} Competition | ${competition.location?.name ?
        competition.location.name : competition.location?.country?.name} | ${this.partnerSlug.charAt(0).toUpperCase()
        + this.partnerSlug.slice(1)}`;
      const description = `${this.modules.map(module => module.sub_heading + ' ' +
        (module.partners ? module.partners.map(partner => ' ' + partner.organization.title + ' ') : ' '))}`;

      const image = competition.image ? this.renderImage(competition.image) : '';
      metaInfo = [
        { name: 'title', content: title },
        { name: 'description', content: description },
        { name: 'url', content: window.location.href },
        { name: 'image', content: image },
        { name: 'twitter:card', content: 'summary_large_image' },
        { name: 'twitter:title', content: title },
        { name: 'twitter:description', content: description },
        { name: 'twitter:url', content: window.location.href },
        { name: 'twitter:image', content: image },
        { property: 'og:title', content: title },
        { property: 'og:description', content: description },
        { property: 'og:url', content: window.location.href },
        { property: 'og:image', content: image },
        { property: 'og:image:alt', content: title },
        { property: 'og:type', content: 'website' }
      ];
      metaInfo.forEach(meta => {
        this.metaService.updateMetaInfo(meta);
      });
      this.metaService.updateMeta(metaInfo);
      this.metaService.updateTitle(title);
      this.metaService.createCanonicalURL();
    });
  }

  goToWebsite(link: string): void {
    if (link) {
      window.open(link, '_blank');
    }
  }

  renderImage(image: string): string {
    return this.imageOptimizer.renderImage(image, window.innerWidth, '');
  }
}
